import React from "react";
import classNames from "classnames";
import {TableButtonProps} from "@components/dataTable/buttons";
import {downloadFile, useDownloadFile} from "@hooks/useDownloadFile";
import {IconDownload, IconFolder} from "@tabler/icons-react";

interface PreviewButtonProps extends TableButtonProps {
    srcFile: string | undefined | null,
    onFulfilled?: () => void,
}

export const Preview: React.FC<PreviewButtonProps> = ({srcFile, className, disabled, onFulfilled}) => {
    const postDownloading = () => {
        if (onFulfilled)
            onFulfilled();
    }
    const {open} = useDownloadFile({
        apiDefinition: () => downloadFile(srcFile, 'inline'),
        postDownloading,
        getFileName: () => 'file',
    });
    return <> {srcFile &&
        // <span className={classNames(className, "last:mr-2")}>
        <button className={`${className} text-gray-500 hover:text-gray-700 disabled:opacity-25 last:mr-2`} disabled={disabled}
                onClick={() => open()}>
            <IconFolder className="h-5 w-5" aria-hidden="true"/>
        </button>
        // </span>
    }</>;
}

export const DownloadFile: React.FC<PreviewButtonProps> = ({className, disabled, srcFile, onFulfilled}) => {
    const postDownloading = () => {
        if (onFulfilled)
            onFulfilled();
    }
    const {ref, url, download, name} = useDownloadFile({
        apiDefinition: () => downloadFile(srcFile),
        postDownloading,
    });

    return (
        <span className={classNames(className, "last:mr-2")}>
            {/*<a href={url} download={name} className="hidden" ref={ref}/>*/}
            <button className="text-sky-400 enabled:hover:text-sky-600 disabled:opacity-50" disabled={disabled}
                /*onClick={()=>axiosDownloadFile(srcFile!,'pippo.pdf')}*/
                    onClick={() => download()}
            >
            <IconDownload className="h-5 w-5" aria-hidden="true"/>
            </button>
        </span>);
}
